import React from "react";
import { Container, Contents, ItemTitle, Title } from "../styles";

const ApproveMarketing = () => {
  return (
    <Container>
      <Title>마케팅 정보 활용</Title>

      <Contents>
        <span>
          “브이디김대표”에서는 고객님께 보다 나은 서비스를 제공하기 위하여,
          「신용정보의 이용 및 보호에 관한 법률」 제 15조제2항, 제 32조제1항,
          제33조, 제34조 및 「개인정보보호법」 제 15조제1항, 제17조제1항,
          제24조제1항, 제24조의2에 따라 마케팅과 관련하여 개인(신용) 정보 활용에
          대한 동의를 받고자 합니다. 아래의 내용을 읽어보시고 동의하여 주시기
          바랍니다.
        </span>

        <ItemTitle> 활용 목적 수집 항목 방법 보유 및 이용기간</ItemTitle>

        <ol>
          <li>혜택 제공(포인트, 쿠폰) 정보 제공 </li>
          <li>각종 이벤트 정보 등 광고성 메시지의 수신 </li>
          <li>
            당사 및 제휴사 상품/서비스 안내 제공 및 권유, 고객별 맞춤
            상품/서비스 추천, 정보 제공 이름, 사업장명, 사업자등록번호,
            연락처(휴대전화번호), 이메일주소 앱푸시 알림, 전화, 문자(SMS, LMS,
            MMS), 카카오 알림톡, 이메일 회원탈퇴 또는 동의 철회 시까지 보유
            고객님께서는 선택 동의를 거부할 권리가 있으며, 정상적인 회원가입은
            가능하나, 동의 거부 시 상품/서비스 안내 및 홍보/이벤트 등의
            정보제공이 불가합니다. 중요 공지 및 알림은 설정에 관계없이 발송될 수
            있습니다. 수신 동의 여부 및 자세한 설정은 고객센터(1833-3482)를
            통해서 수신 동의를 변경(동의/철회)할 수 있습니다.
          </li>
        </ol>
      </Contents>
    </Container>
  );
};

export default ApproveMarketing;
